import Styles from './CertificateGenerator.module.scss';
import React,{ useContext } from 'react';
// Module imports.
import _ from 'lodash';
// Components import
import { Logo, AuthContext } from 'components/lib';
// Assets import.
import nasscomlogo from 'assets/icons/nasscomlogo.png';

/**
 * @param {string} firstName First Name of the user for whom certificate has to be generated
 * @param {string} lastName Last Name of the user for whom certificate has to be generated
 * @param {string} message Message to be included as part of the Certificate containing details
 * @param {string} issueDate Date of the certificate issuance
 *
 */
export const CertificateGenerator = React.forwardRef(({ id, firstName, lastName, message, issueDate, isMicroCert = false, userCertId = '', ...props},ref) => {

	const authContext = useContext(AuthContext);
	const isProdEnv = process.env.REACT_APP_PRODUCTION;

	return (
		<>
			<div ref={ref} className={Styles.container} id={id}>
				<img src={`${process.env.REACT_APP_GLOBAL_MEDIA_URL}/topos-icons/global/certificate_watermark.png`} style={{ display: isProdEnv === "true" ? "none" : "" }} alt="Watermark" className={Styles.watermark} />
				<div className={`${Styles.rightAngle} ${Styles.topSecond}`} />
				<div className={`${Styles.rightAngle} ${Styles.topLeft}`} />
				<div className={`${Styles.rightAngle} ${Styles.bottomLeft}`}></div>
				{!isMicroCert && <img className={Styles.nasscomlogo} src={nasscomlogo} alt="Logo" />}
				{/* <img className={Styles.tgtlogo} src={orgLogo ? orgLogo : tgtlogo} alt="Logo" width="200" height="69" /> */}
				<Logo color="short" />
				<div className={Styles.certContent}>
					{isMicroCert ?
						<h4>MicroCertificate</h4>
						:
						<h2>Certificate</h2>
					}
					<p>of completion</p>
					<p className={Styles.line3}>this is to certify that</p>
					<p className={Styles.name}>
						{_.startCase(_.toLower(firstName))} {_.startCase(_.toLower(lastName))}
					</p>
					<div className={Styles.underline} />
					<p className={Styles.subPara}>has completed a certification in</p>
					<p className={Styles.certName}>{message}</p>
					<div className={Styles.footer}>
						<p>On AIVAGAM</p>
						<p>
							<u>Issued By</u>
						</p>
						<p className={Styles.topgrep}>{authContext?.user?.accounts[0]?.whitelabel ? authContext?.user?.accounts[0]?.name : "TopGrep Tech Pvt Ltd"}</p>
						<p>Issued On {issueDate}</p>
					</div>
					<div className={Styles.qrCodeContainer}>
						{props.qrCode}
					</div>
					{
						userCertId &&
						<span className={Styles.usercertid}>Cert ID: {userCertId}</span>
					}
					{
						authContext?.user?.accounts[0]?.whitelabel === 1 &&
						<span className={Styles.poweredby}>Powered By TopGrep</span>
					}
				</div>
			</div>
		</>
	);
});